module.exports = __webpack_public_path__ + "assets/img/27_1249.12cc5a45.jpg";